<template>
  <v-toolbar app :clipped-left="clipped" height="70" class="app-navbar white">
    <v-toolbar-side-icon
      class="btn-mini-variant"
      @click.stop="$store.commit('layout/toggleMiniVariant')"
    ></v-toolbar-side-icon>
    <v-toolbar-side-icon
      class="btn-drawer"
      @click.stop="$store.commit('layout/toggleDrawer')"
    ></v-toolbar-side-icon>
    <!-- <v-menu
      transition="slide-y-transition"
      bottom
    >
      <template v-slot:activator="{ on }">
        <v-tooltip bottom>
          <v-btn icon slot="activator" v-if="loading === false" v-on="on">
            <v-icon>check</v-icon>
          </v-btn>
          <v-progress-circular
            v-if="loading === true"
            slot="activator"
            indeterminate
            color="green"
            v-on="on"
          ></v-progress-circular>
          <span>Tareas en segundo plano</span>
        </v-tooltip>
      </template>

      <v-card v-if="tareas.length > 0">
        <v-card-title>
          Tareas en segundo plano
        </v-card-title>
        <v-card-text>
          <p
            v-for="tarea in tareas"
            :key="tarea.tarea"
          >
            <v-btn
              color="success"
              icon
              :loading="tarea.estado"
            >
              <v-icon>check</v-icon>
            </v-btn>
            {{ tarea.tarea }}
          </p>
        </v-card-text>
      </v-card>

      <v-card v-if="tareas.length === 0">
        <v-card-text>
          <p>
            No hay tareas en segundo plano
          </p>
        </v-card-text>
      </v-card>

    </v-menu> -->
    <v-spacer></v-spacer>
    <app-lang></app-lang>
    <v-tooltip bottom>
      <v-btn icon @click="fullscreen()" class="btn-fullscreen" slot="activator">
        <v-icon>fullscreen</v-icon>
        <v-icon>fullscreen_exit</v-icon>
      </v-btn>
      <span>Pantalla completa</span>
    </v-tooltip>
    <v-tooltip bottom>
      <v-btn icon @click="reload" slot="activator">
        <v-icon>refresh</v-icon>
      </v-btn>
      <span>Actualizar la página</span>
    </v-tooltip>
    <v-btn icon @click.stop="$store.commit('layout/toggleRightDrawer')">
      <v-icon>notifications</v-icon>
    </v-btn>
    <v-menu
      offset-x
      :close-on-content-click="false"
      max-width="320"
      min-width="320"
    >
      <v-toolbar-title slot="activator">
        <v-avatar class="info">
          <span class="white--text headline">{{ inicial }}</span>
        </v-avatar>
      </v-toolbar-title>
      <v-card>
        <v-container grid-list-md class="menu-person">
          <v-layout row wrap>
            <!-- <v-flex xs2 text-md-center>
              <v-avatar
                class="info"
                size="64"
              >
                <span class="white--text headline">{{ inicial }}</span>
              </v-avatar>
            </v-flex> -->
            <v-flex>
              <h3>{{ nombreCompleto }}</h3>
              <v-icon>mail</v-icon> {{ user.email }}<br />
              <v-icon>home</v-icon> {{ unidad }}<br />
              <v-icon>face</v-icon> {{ cargo }}<br />
              <span v-for="rol in user.roles" :key="rol.id"
                ><v-icon>person_pin</v-icon> {{ rol.descripcion }} <br
              /></span>
              <!-- <v-icon>location_city</v-icon>{{ user.entidad }} -->
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider></v-divider>
        <v-list>
          <v-list-tile @click="$router.push('account')">
            <v-list-tile-title>
              <v-icon>account_circle</v-icon> {{ $t("app.account") }}
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>
              <v-icon>&#xE8AC;</v-icon> {{ $t("app.logOut") }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-menu>
  </v-toolbar>
</template>

<script>
import Auth from "@/components/admin/auth/mixins/auth";
import AppLang from "./AppLang";
import { mapState } from "vuex";

export default {
  mixins: [Auth],
  data: () => ({
    clipped: false,
    tareas: [],
    loading: false,
    cargo: "",
    unidad: "",
  }),
  async mounted() {
    this.$bus.$on("insertarTarea", (object) => {
      this.tareas.push(object);
      this.loading = true;
    });
    this.$bus.$on("terminarTarea", (object) => {
      for (let i = 0; i < this.tareas.length; i++) {
        if (this.tareas[i].tarea === object.tarea) {
          this.tareas[i].estado = false;
        }
      }
      this.loading = this.verificaEstado();
    });
    await this.obtenerCargo();
  },
  methods: {
    fullscreen() {
      document.querySelector("body").classList.toggle("fullscreen");
      this.$util.fullscreen();
    },
    verificaEstado() {
      for (let i = 0; i < this.tareas.length; i++) {
        if (this.tareas[i].estado == true) {
          return true;
        }
      }
      return false;
    },
    async obtenerCargo() {
      try {
        let user = this.$storage.get("user");
        if (user.unidad.length > 0) {
          this.unidad = user.unidad[0].nombre_unidad;
          let res = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "select c.denominacion,m.id_tipo_justificacion,c.id from movilidad.movilidad m ,movilidad.cargo c where m.id_cargo =c.id and m.id_persona =${user.id_persona} and m.id_estado in (1,53) and m.id_tipo_justificacion not in (5,6,10,13)"){
                  respuesta
                }
              }
            `,
          });
          if (
            res.runQuery.respuesta &&
            res.runQuery.respuesta[0].denominacion
          ) {
            if (res.runQuery.respuesta[0].id_tipo_justificacion==11) {
              let res2 = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "select c.denominacion as cargo from movilidad.movilidad m left join movilidad.interinato i on i.id_movilidad =m.id left join movilidad.cargo c on c.id=i.id_cargo left join movilidad.puesto pu on pu.id=i.id_puesto where m.id_persona =${user.id_persona} and m.id_estado in (1,53) and m.id_tipo_justificacion not in (5,6,10,13)"){
                  respuesta
                }
              }
            `,
          });
          this.cargo = res2.runQuery.respuesta[0].cargo;
            }else{
              this.cargo = res.runQuery.respuesta[0].denominacion;
            }}
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  components: { AppLang },
  computed: {
    ...mapState(["user"]),
    nombreCompleto() {
      let user = this.$store.state.user;

      return `${user.nombres} ${user.ap_paterno} ${user.ap_materno}`;
    },
    inicial() {
      let user = this.$store.state.user;
      if (user.nombres) {
        return (user.nombres[0] || "?").toUpperCase();
      }
      return "?";
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/_variables.scss";

.app-navbar {
  box-shadow: 0px 1px 15px 1px rgba(69, 65, 78, 0.1);

  .v-toolbar__content {
    padding: 0 15px;
  }

  .v-btn .v-icon {
    color: $color;
  }

  .menu-user {
    margin-right: 10px;
    .v-toolbar__title {
      font-size: 16px;
      color: $color;
    }
    .v-icon {
      font-size: 40px;
    }
  }

  .btn-mini-variant {
    display: inline-block;
  }
  .btn-drawer {
    display: none;
  }
}

.btn-fullscreen {
  .v-icon:last-child {
    display: none;
  }
}

body.fullscreen {
  .btn-fullscreen {
    .v-icon:first-child {
      display: none;
    }
    .v-icon:last-child {
      display: inline-block;
    }
  }
}

.menu-person {
  color: lighten($secondary, 10%);
  font-size: 1rem;
  padding: 10px 15px;
  background-color: darken($primary, 5%);
  background-image: url(../../assets/images/profile.png);
  background-position: center;
  background-size: cover;

  h3 {
    font-size: 1.3rem;
    color: white;
    font-weight: 400;
  }

  .v-icon {
    color: white !important;
    font-size: 1.1rem;
  }
}

@media (max-width: 1256px) {
  .app-navbar {
    .btn-mini-variant {
      display: none;
    }
    .btn-drawer {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/layout/AppNavbar.vue